import { useParams } from 'react-router';

import { useGetContactQuery, useGetMainPageQuery } from '@/api/endpoints/mainPages';
import { FetchDataWrapper } from '@/shared/components';

import { transformDateToCorrectFormat } from '../helpers';

import { MainContactPageComponent } from './MainContactPageComponent';

export const MainContactPage = () => {
  const { id } = useParams();
  const {
    data: pageData,
    isLoading: isPageLoading,
    isError: isPageDataFetchError,
  } = useGetMainPageQuery({ id: Number(id) });
  const {
    data: contactData,
    isLoading: isContactLoading,
    isError: isContactFetchError,
  } = useGetContactQuery({ id: Number(id) });

  return (
    <FetchDataWrapper
      isLoading={isPageLoading || isContactLoading}
      isError={isPageDataFetchError || isContactFetchError}
    >
      {pageData && contactData && (
        <MainContactPageComponent
          contactData={contactData}
          pageName={transformDateToCorrectFormat(pageData.created_at)}
          pageId={pageData.id}
        />
      )}
    </FetchDataWrapper>
  );
};
